// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "./assets/build/main." + {"130":"2ac44c01970ff0864777","447":"2ac44c01970ff0864777","527":"2ac44c01970ff0864777","650":"2ac44c01970ff0864777"}[chunkId] + ".min.css";
};